import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Scorecard, ScorecardQuery, ScorecardService } from '@fgb/core';
import { ScorecardCategoryPunchcardView } from '../../scorecard-categories';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ScorecardDescriptionComponent } from '../../scorecard-description/scorecard-description.component';

@Component({
  selector: 'fgbcl-scorecard-punchcard-view',
  templateUrl: './scorecard-punchcard-view.component.html',
  styleUrls: ['./scorecard-punchcard-view.component.scss', '../scorecard-display-shared.scss'],
})
export class ScorecardPunchcardViewComponent implements OnInit {
  @Input() scorecard: Scorecard;
  @Input() confettiColors: string[];
  @Input() icon: string = 'info';
  @Input() disabled: boolean = false;
  isOpenModal: boolean = true;
  @Input() isSponsorInBody: boolean = false;
  lineBreakIndex: number;
  category = ScorecardCategoryPunchcardView;
  isScorecardHasChild: boolean = false;
  constructor(
    private offcanvasService: NgbOffcanvas,
    private router: Router,
    private scorecardService: ScorecardService,
    private scorecardQuery: ScorecardQuery
  ) {}

  ngOnInit() {
    this.lineBreakIndex = Math.floor(this.scorecard.Actions.length / 2) - 1;
    this.isScorecardHasChild = this.scorecardQuery.hasLinkedScorecards(this.scorecard.ScorecardId);
    this.onWindowResize(window.innerWidth);
  }

  @HostListener('window:resize', ['$event.target.screen.width'])
  onWindowResize(event: number) {
    if (event > 576) {
      this.isOpenModal = true;
    } else {
      this.isOpenModal = false;
    }
  }

  openScorecardDescription() {
    if (!this.disabled) {
      this.isOpenModal ? this.openModal() : this.redirectComponent();
    }
  }

  openModal() {
    const offcanvasRef = this.offcanvasService.open(ScorecardDescriptionComponent, {
      position: 'bottom',
      panelClass: 'scorecard-offcanvas-content',
    });
    offcanvasRef.componentInstance.confettiColors = this.confettiColors;
    offcanvasRef.componentInstance.scorecardId = this.scorecard.ScorecardId;
    offcanvasRef.componentInstance.isSponsorInBody = this.isSponsorInBody;
  }

  redirectComponent() {
    const initVal = {
      confettiColors: this.confettiColors,
    };
    let params = this.isSponsorInBody ? { isSponsorInBody: this.isSponsorInBody } : {};

    this.scorecardService.initDataScorecardDescription$.next(initVal);
    this.router.navigate(['/scorecard-description', this.scorecard.ScorecardId, params]);
  }
}
